import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";

const JournalVoucher = () => {
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  return (
    <>
      Journal Voucher Posting
    </>
  );
};

export default JournalVoucher;